import script from "./QuestionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionModal.vue?vue&type=script&setup=true&lang=js"

import "./QuestionModal.vue?vue&type=style&index=0&id=480ea73c&lang=scss"

const __exports__ = script;

export default __exports__